import { HttpClient } from '@/api/services/HttpClient';
export interface StripeConnection {
  id: string | null; name: string; connected: boolean; mode: 'test'; updatedAt: string | null;
  actions: {name: string; label: string; endpoint: string; enabled: boolean}[];
  copilots: {id: string; name: string; enabled: boolean}[];
}
const base = '/integrations/stripe';
export const stripeIntegrationService = {
  status: async (): Promise<StripeConnection> => (await HttpClient.apiClient.get(base)).data.data,
  connect: async (apiKey: string): Promise<StripeConnection> => (await HttpClient.apiClient.post(base, {apiKey})).data.data,
  test: async () => (await HttpClient.apiClient.post(base + '/test', {})).data.data,
  actions: async (actions: string[]): Promise<StripeConnection> => (await HttpClient.apiClient.patch(base + '/actions', {actions})).data.data,
  copilot: async (id: string, enabled: boolean): Promise<StripeConnection> => (await HttpClient.apiClient.put(base + '/copilots/' + id, {enabled})).data.data,
  disconnect: async (): Promise<StripeConnection> => (await HttpClient.apiClient.delete(base, {data: {}})).data.data,
};
